// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2TZ07","footer":"ChangeClinic_footer__1bODf"};